
const ACCOUNT_PAGE = 'Account'
const ACCOUNT_SIGN_IN = 'Sign In'
const ACCOUNT_SIGN_UP = 'Sign Up'
const ACCOUNT_PASSWORD_RECOVERY = 'Password Recovery'
const CREATE_TRANSACTION_REQUEST = 'Send Payment'
const CREATE_TRANSACTION_REQUEST_RESPONSE = 'Transaction Completed'


export {
  ACCOUNT_PAGE,
  ACCOUNT_SIGN_IN,
  ACCOUNT_SIGN_UP,
  ACCOUNT_PASSWORD_RECOVERY,
  CREATE_TRANSACTION_REQUEST,
  CREATE_TRANSACTION_REQUEST_RESPONSE
}

